/** Filter attribute keys used in the medical PA worklist UI (maps to Algolia/Postgres field names). */
export enum MedicalPaFilterKey {
  DocStatus = "doc_status",
  RegimenNames = "regimen_name",
  AuthVerificationStatus = "auth_status",
  BoStatus = "bo_status",
  EstimateValue = "estimate_value",
  EvWriteBackStatus = "ev_write_back_status",
  DocumentUploadStatus = "document_upload_status",
  DateOfService = "date_of_service",
  CreatedAt = "created_at",
  DateOfWork = "date_of_work",
  PrimaryPayerName = "primary_payer_name",
  PractitionerName = "practitioner_name",
  Location = "location",
  AuthStatus = "auth_status",
  Assignee = "assigned_to",
  RegimenType = "regimen_type",
  EvPrimary = "ev_bv_primary",
  OrderStateStatus = "medical_order_status",
  ReviewStatus = "medical_order_review_status",
  SecondaryPayerName = "secondary_payer_name",
  NccnAiEvaluation = "nccn_ai_evaluation",
  NccnHumanValidation = "nccn_human_validation",
}

/**
 * Sentinel sent as `nccn_ai_evaluation` when the user selects AI Verdict "Not Run".
 * The backend projects missing `nccn_guideline_evaluations` rows to this value
 * (`CASE WHEN ne.order_id IS NULL THEN '__not_run__'`).
 */
export const NCCN_AI_EVALUATION_NOT_RUN = "__not_run__";

/** Subset of filter keys specifically fetched as facets from the Postgres backend. */
export enum MedicalPaFilterKeysToFetchFromPostgres {
  RegimenNames = "regimen_name",
  PrimaryPayerName = "primary_payer_name",
  PractitionerName = "practitioner_name",
  Location = "location",
  RegimenType = "regimen_type",
  EvPrimary = "ev_bv_primary",
  MasterAuthStatus = "master_auth_status",
  SecondaryPayerName = "secondary_payer_name",
}

/**
 * Returns all medical PA filter key values as a string array.
 * @returns Array of filter key strings.
 */
export const getAllMedicalPaFilterKeys = (): string[] =>
  Object.values(MedicalPaFilterKey);

/**
 * Returns the subset of filter keys that are fetched from the Postgres backend.
 * @returns Array of Postgres-specific filter key strings.
 */
export const getAllMedicalPaFilterKeysToFetchFromPostgres = (): string[] =>
  Object.values(MedicalPaFilterKeysToFetchFromPostgres);
